import React from "react"
import { H2 } from "@carrotfertility/carotene"
import { useStateMachine } from "components/context/stateMachine/StateMachineContext"
import { Spacer } from "components/views/atoms/Atoms"
import {
  BenefitEnrollmentFlowModalBackButton,
  BenefitEnrollmentModalFormSelect,
  BenefitEnrollmentModalContinueButton
} from "../shared"
import useSubmitWithErrorCatch from "../hooks/useSubmitWithErrorCatch"
import { Steps } from "../workflow/steps"
import { useProgressTracker } from "components/views/modal/ProgressTracker"
import { FormProvider, useForm } from "react-hook-form"
import { useCurrentUser } from "components/context/user/UserContext"
import { useUserDeductible } from "../../context/user/DeductibleContext"
import { FormattedMessage, useIntl } from "react-intl"

const FieldName = "memberHasLegalPartnerValue"
const ViewName = Steps.MEMBER_HAS_LEGAL_PARTNER

export function DoYouHavePartnerStep(): JSX.Element {
  const { setProgress } = useProgressTracker()
  const { memberHasLegalPartner } = useCurrentUser()
  const { updateBenefitEnrollmentAnswers } = useUserDeductible()
  const formMethods = useForm()
  const { setNextStep } = useStateMachine(ViewName, memberHasLegalPartner)
  // @ts-expect-error TS7006
  const { onSubmit } = useSubmitWithErrorCatch(async (args) => {
    const val = args[FieldName].value
    await updateBenefitEnrollmentAnswers({ memberHasLegalPartner: val })
    setNextStep(ViewName, val)
  })
  const intl = useIntl()
  setProgress(1, intl.formatMessage({ defaultMessage: "YOUR INSURANCE COVERAGE" }))

  const { handleSubmit } = formMethods

  return (
    <FormProvider {...formMethods}>
      <BenefitEnrollmentFlowModalBackButton />

      <Spacer height={3} />
      <H2 variant="primary">
        <FormattedMessage defaultMessage="Do you have a partner?" />
      </H2>
      <Spacer height={2} />
      <BenefitEnrollmentModalFormSelect
        name={FieldName}
        defaultValue={memberHasLegalPartner}
        options={[
          { label: intl.formatMessage({ defaultMessage: "Yes" }), value: "true" },
          { label: intl.formatMessage({ defaultMessage: "No" }), value: "false" }
        ]}
      />
      <Spacer height={4} />
      <BenefitEnrollmentModalContinueButton onClick={handleSubmit(onSubmit)} />
    </FormProvider>
  )
}
